import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgApproved = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#approved_svg__a)">
      <path
        d="m15.794 9.384-.247-.332a1.027 1.027 0 0 1-.01-1.216l.24-.334a1.032 1.032 0 0 0-.367-1.522l-.368-.193a1.033 1.033 0 0 1-.546-1.092l.07-.403c.107-.616-.364-1.187-1.003-1.213l-.419-.016a1.063 1.063 0 0 1-.977-.751l-.117-.394c-.177-.603-.853-.914-1.442-.665l-.385.16a1.075 1.075 0 0 1-1.21-.262l-.28-.305A1.075 1.075 0 0 0 7.142.86l-.275.309c-.3.337-.786.449-1.208.278l-.388-.157a1.07 1.07 0 0 0-1.432.688l-.11.397c-.12.433-.509.741-.964.764l-.418.023c-.64.036-1.1.613-.984 1.23l.077.403c.084.439-.13.882-.528 1.098l-.365.2a1.029 1.029 0 0 0-.341 1.524l.247.332c.268.36.275.849.01 1.216l-.24.334A1.032 1.032 0 0 0 .59 11.02l.368.193c.402.21.623.65.546 1.092l-.07.403c-.108.616.364 1.187 1.003 1.213l.419.016c.455.02.85.322.977.751l.117.394c.177.603.853.914 1.442.665l.385-.16a1.075 1.075 0 0 1 1.21.262l.279.305a1.075 1.075 0 0 0 1.592-.013l.275-.309c.3-.337.786-.449 1.208-.278l.388.157a1.07 1.07 0 0 0 1.432-.688l.11-.397c.12-.433.509-.741.964-.764l.418-.023c.64-.036 1.1-.613.984-1.23l-.077-.403c-.084-.439.13-.882.528-1.098l.365-.2c.559-.302.72-1.016.341-1.524Z"
        fill="#007AFF"
      />
      <path d="m4.25 9.155 3.067 2.596L12.248 5.5" stroke="#fff" />
    </g>
    <defs>
      <clipPath id="approved_svg__a">
        <path fill="#fff" transform="translate(0 .5)" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
const Memo = memo(SvgApproved);
export default Memo;
